import React from "react"
import {Accordion, AccordionDetails, AccordionSummary, Typography, Button} from "@mui/material"
import {ExpandMore as ExpandMoreIcon, Warning as CaseEscalatedIcon} from "@mui/icons-material"
import styled from "styled-components"
import {useNavigate} from "react-router-dom"

import {CustomerCaseEscalatedActivityPayload} from "@indebted/api"

function CaseEscalatedActivity(
	panelId: number,
	{Title, HappenedAt, Payload}: {Title: string; HappenedAt: string; Payload: CustomerCaseEscalatedActivityPayload},
	expanded: boolean,
	handleExpand: (panelID: number) => (event: any, isExpanded: boolean) => void,
	classes: {summary: string; activityContent: string},
	customerID: string,
) {
	const navigate = useNavigate()

	if (!Payload.CaseID) {
		return (
			<AccordionNoContent expanded={false}>
				<AccordionSummary>
					<CaseEscalatedIcon color="primary" />
					<Typography className={classes.summary}>
						{" "}
						<b>{Title}</b> - {HappenedAt}
					</Typography>
				</AccordionSummary>
			</AccordionNoContent>
		)
	}

	return (
		<Accordion expanded={expanded} onChange={handleExpand(panelId)}>
			<AccordionSummary expandIcon={<ExpandMoreIcon />}>
				<CaseEscalatedIcon color="primary" />
				<Typography className={classes.summary}>
					{" "}
					<b>{Title}</b> - {HappenedAt}
				</Typography>
			</AccordionSummary>
			<AccordionDetails>
				{expanded && (
					<div className={classes.activityContent}>
						<div>
							<Button
								size="small"
								variant="outlined"
								onClick={() => navigate(`/customers/${customerID}/cases?CaseID=${Payload.CaseID}`)}
								sx={{textTransform: "none", fontSize: "0.75rem", fontWeight: 600}}
							>
								See Case
							</Button>
						</div>
					</div>
				)}
			</AccordionDetails>
		</Accordion>
	)
}

const AccordionNoContent = styled(Accordion)`
	.MuiAccordionSummary-content {
		cursor: default;
	}
`

export {CaseEscalatedActivity}
